import { enumLotStatus, LotStatus } from '@rematter/frontend-lib-api-client';
import { Badge } from '@rematter/ui-web';

import { useTranslations } from '../../i18n/useTranslations';

type LotStatusBadgeProps = {
  status: LotStatus;
};

const STATUS_BADGE_COLOR: Record<
  LotStatus,
  'neutral' | 'success' | 'warning' | 'failure'
> = {
  [enumLotStatus.Active]: 'success',
  [enumLotStatus.Closed]: 'neutral',
  [enumLotStatus.Merged]: 'warning',
};

export const LotStatusBadge = ({ status }: LotStatusBadgeProps) => {
  const t = useTranslations();

  return (
    <Badge color={STATUS_BADGE_COLOR[status]} className="@LotStatusBadge">
      {t.lotsListView.statusTypes[status]}
    </Badge>
  );
};
